(function($) {

  //  Menu Highlights
  //  Menu van Presentatie is verwerkt in slideControler, werkt vergelijkbaar

  // Alles gaat op class + element


  if( $('body').hasClass('page-template-template-highlights') ||
    $('body').hasClass('page-template-template-preview') ) {

    // Menu with scrollTo

    var old_category = 'ambitie';

    $('[href="#highlights"]').on('click', function(e) {
      e.preventDefault();
      var
        $this = $(this),
        slide_to_element = $this.attr('slide-to-element');
        gsap.to(window, {duration: 1, scrollTo: slide_to_element });
    });

    function change_category( new_category ) {
      var $menus = $('#Midnight');
        $menus.removeClass(old_category);
        $menus.addClass(new_category);
        old_category= new_category;
    }

    // ScrollTrigger
    ScrollTrigger.create({
      trigger: document.querySelector(".page-header--wrapper"),
      start: "top 50%",
      end: "bottom 50%",
      onToggle: self => { change_category( 'ambitie' )  },
    });

    ScrollTrigger.create({
      trigger: document.querySelector(".block__container--wrapper.missies"),
      start: "top 50%",
      end: "bottom 50%",
      onToggle: self => {  change_category( 'missie' ) },
    });

    ScrollTrigger.create({
      trigger: document.querySelector(".block__container--wrapper.speerpunten"),
      start: "top 50%",
      end: "bottom 50%",
      onToggle: self => { change_category( 'speerpunten' )  },
    });

    ScrollTrigger.create({
      trigger: document.querySelector(".block__two-columns__custom.vitale-regio"),
      start: "top 50%",
      end: "bottom 50%",
      onToggle: self => { change_category( 'vitale-regio' )  },
    });

    ScrollTrigger.create({
      trigger: document.querySelector(".block__container--wrapper.organisatie"),
      start: "top 50%",
      end: "bottom 50%+",
      onToggle: self => { change_category( 'organisatie' )  },
    });


  }

})(jQuery);